export default "__VITE_PUBLIC_ASSET__5201e6f7__"